import Cookies from 'js-cookie'
import {getCurrentSiteEnv} from '@/api/lib/stream'
// error上报
function jsMonitor (errorData) {
  try {
    errorData && window.__sgm__ && window.__sgm__.error(errorData)
  } catch (error) {
    console.log(error)
  }
}

/**
 * sgm自定义探针自定义上报封装
 * @param { Number } type - 自定义类型(e.g. 1-error,2-warn,3-info)
 * @param { String } code - 自定义探针key SGM_模块_子模块_功能(i.g. SGM_goods_base_add)
 * @param { Object } msg - 探针描述
 * @param { string } msg.desc - 描述
 * @param { string } error - 异常信息
 * @param { Object } params - 请求参数
*/
function customMonitor (errData) {
  // const {type = 2, code, msg, cos1 = 0, cos2 = 0, cos3 = 0, cos4 = 0} = errData
  // const env = Cookies.get('lwms.env') || 'test'
  // if(process.env.NODE_ENV === 'production' && env !== 'test' && getCurrentSiteEnv() !== 'test'){
  //   try {
  //     errData && window.__sgm__ && window.__sgm__.custom({
  //       type,
  //       code,
  //       msg: JSON.stringify({...msg, env}),
  //       cos1,
  //       cos2,
  //       cos3,
  //       cos4
  //     })
  //   } catch (error) {
  //     console.warn('custom SGMmonitor error: ', error)
  //   }
  // }
  
}

function printCustomMonitor(errData) {
  const { type = 2, code, msg, cos1 = 0, cos2 = 0, cos3 = 0, cos4 = 0 } = errData
  const env = Cookies.get('lwms.env') || 'test'
  if (process.env.NODE_ENV === 'production' && env !== 'test' && getCurrentSiteEnv() !== 'test') {
    console.log("🚀 ~ printCustomMonitor ~ errData:", errData)
    try {
      errData && window.__sgm__ && window.__sgm__.custom({
        type,
        code,
        msg: JSON.stringify({ ...msg, env }),
        cos1,
        cos2,
        cos3,
        cos4
      })
    } catch (error) {
      console.warn('custom SGMmonitor error: ', error)
    }
  }

}
/**
 * api上报
 * @param {string} url 请求地址 必加
 * @param {string} status 响应状态 必加
 * @param {string} data 响应数据
 */
function apiMonitor (requestBody ={}, responseData ={}) {
  const {url} = requestBody
  const {status, data} = responseData
  try {
    window.__sgm__ && window.__sgm__.api({ 
      url: url,
      status: status,
      requestBody,
      responseData: {status, data}
    })
  } catch (error) {
    console.log(error)
  }
}

export default {
  jsMonitor,
  customMonitor,
  apiMonitor,
  printCustomMonitor,
}